import { ListItemIcon, Menu, MenuItem } from "@mui/material";

import { FileActionsMenuItem } from "./FileActionsMenu.types";

interface Props {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  items: FileActionsMenuItem[];
  minWidth?: number;
}

/** Kebab menu for per-file actions, shared by the DropZone and file-list rows. */
export function FileActionsMenu({ anchorEl, onClose, items, minWidth = 260 }: Props) {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose} slotProps={{ paper: { sx: { minWidth } } }}>
      {items.map((item) => (
        <MenuItem
          key={item.key}
          disabled={item.disabled}
          onClick={() => {
            item.onClick();
            onClose();
          }}
        >
          {item.icon !== undefined && <ListItemIcon>{item.icon}</ListItemIcon>}
          {item.label}
        </MenuItem>
      ))}
    </Menu>
  );
}
